import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'

import { Button } from 'core-components/library/button'

import { ICompletedPartners } from '../../../models/ICompletedPartners'
import { baseColumns } from '../config'

interface IGetColumns {
  onOpenPartnerPlan?: (item: ICompletedPartners) => void
}

export const getColumns = ({ onOpenPartnerPlan }: IGetColumns) => {
  const additionalColumns = []

  if (onOpenPartnerPlan) {
    additionalColumns.push({
      field: `SelectPartner`,
      title: '',
      priority: 7,
      hideSettings: true,
      renderFunction: (item: ICompletedPartners) => {
        return (
          <div>
            <RenderWhen condition={!!onOpenPartnerPlan}>
              <Button
                variant={'text'}
                iconButton={'kbase kbase-link'}
                color={'primary'}
                onClick={() => onOpenPartnerPlan(item)}
              />
            </RenderWhen>
          </div>
        )
      },
    })
  }

  return [...baseColumns, ...additionalColumns]
}
